"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var trash_png_1 = __importDefault(require("assets/img/trash.png"));
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AnalyticEvents_1 = __importDefault(require("../../../utils/AnalyticEvents"));
var styles_1 = require("../styles");
var utils_1 = require("../utils");
var DailyDrawTicket = function (_a) {
    var ticket = _a.ticket, updateTicket = _a.updateTicket, theme = _a.theme, updateBetType = _a.updateBetType, deleteTicket = _a.deleteTicket, ticketIndex = _a.ticketIndex, _b = _a.isNewVersion, isNewVersion = _b === void 0 ? false : _b, isDaily3 = _a.isDaily3, gameName = _a.gameName;
    var classes = (0, styles_1.styles)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        var numberCount = isDaily3 ? 3 : 4;
        var newTicket = __assign(__assign({}, ticket), { numbers: getNewNumbers(ticket.numbers, numberCount) });
        updateTicket(newTicket);
    }, []);
    var updateNumber = function (value, numberIndex) {
        var newValue = value ? Number(value) : null;
        if (newValue === null || newValue <= 9) {
            updateTicket(__assign(__assign({}, ticket), { numbers: ticket.numbers.map(function (number, index) {
                    return index === numberIndex ? newValue : number;
                }) }));
        }
    };
    var onNumberChange = function (event, index) {
        var newValue = event.target.value;
        updateNumber(newValue, index);
        if (newValue.length === 1 && ticket.numbers.length > index + 1) {
            var numberInputs = Object.values(event.target.closest(".".concat(classes.ticketContainer)).getElementsByTagName('input'));
            if (numberInputs.length === 0) {
                return;
            }
            var firstEmptyInput = numberInputs.find(function (el) { return el.value === ''; });
            if (!firstEmptyInput) {
                return;
            }
            firstEmptyInput.focus();
        }
    };
    var onBetTypeChange = function (event) {
        var newBetTypeKey = event.target.value;
        var numberCount = isDaily3 ? 3 : 4;
        var newTicket = __assign(__assign({}, ticket), { numbers: getNewNumbers(ticket.numbers, numberCount) });
        updateTicket(newTicket);
        updateBetType(newBetTypeKey);
    };
    var getNewNumbers = function (numbers, numberCount) {
        if (numbers.length < numberCount) {
            var diff = numberCount - numbers.length;
            var nullArray = Array(diff).fill(null);
            numbers.push.apply(numbers, nullArray);
        }
        else if (numbers.length > numberCount) {
            numbers.splice(numberCount);
        }
        return numbers;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isNewVersion && ticketIndex === 1 && (react_1.default.createElement(core_1.Divider, { style: {
                color: theme.palette.grey[200],
                borderBottomWidth: 1
            } })),
        react_1.default.createElement("div", { className: classes.ticketContainer },
            react_1.default.createElement(core_1.Select, { className: classes.selectInputUpdated, value: ticket.betType, onChange: onBetTypeChange }, Object.values(utils_1.DailyDrawsBetType).map(function (betType) { return (react_1.default.createElement(core_1.MenuItem, { key: betType, value: betType }, betType)); })),
            ticket.numbers.map(function (number, index) {
                var onChange = function (event) { return onNumberChange(event, index); };
                var onBlur = function () {
                    var _a;
                    var analyticsevent = (_a = window === null || window === void 0 ? void 0 : window.analyticsEventMapping) === null || _a === void 0 ? void 0 : _a['AE0118'];
                    if (!!analyticsevent) {
                        AnalyticEvents_1.default.logEvent('AE0118', __assign(__assign({}, analyticsevent), { eventCategory: analyticsevent.eventCategory + '_' + (gameName === null || gameName === void 0 ? void 0 : gameName.toLowerCase().replace(' ', '_')) }));
                    }
                };
                return (react_1.default.createElement(core_1.Input, { className: (0, classnames_1.default)([
                        classes.numberInput,
                        isNewVersion ? classes.numberInputUpdated : ''
                    ]), value: number !== undefined && number !== null ? number === null || number === void 0 ? void 0 : number.toString() : '', key: index, placeholder: '#', onChange: onChange, onBlur: onBlur, classes: { input: classes.centerText } }));
            }),
            ticketIndex > 0 && isNewVersion && (react_1.default.createElement(core_1.Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    marginLeft: 'auto'
                } },
                react_1.default.createElement(core_1.ButtonBase, { style: { width: '100%' }, onClick: function () { return deleteTicket(ticketIndex); } },
                    react_1.default.createElement("img", { alt: 'deleteTicket', src: trash_png_1.default, style: { height: '16px', width: '16px' } }),
                    react_1.default.createElement(core_1.Typography, { variant: "button", style: {
                            color: theme.palette.error.main,
                            textAlign: 'center',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textTransform: 'unset'
                        } }, t('numberChecker.removeTicket')))))),
        isNewVersion && ticketIndex > 0 && (react_1.default.createElement(core_1.Divider, { style: {
                color: theme.palette.grey[200],
                borderBottomWidth: 1
            } }))));
};
exports.default = DailyDrawTicket;
//# sourceMappingURL=DailyDrawTicket.js.map